import React from 'react';
import WordReveal from './WordReveal';

interface SectionHeadingProps {
  index: string; // "01"
  kicker: string; // "SELECTED WORK"
  title: string;
  description?: string;
  align?: 'left' | 'center';
  /** invert colors for use on black sections */
  inverted?: boolean;
}

/**
 * verteal-style section header: bracketed mono micro-label
 * + large medium-weight heading with a masked word reveal.
 */
const SectionHeading: React.FC<SectionHeadingProps> = ({
  index,
  kicker,
  title,
  description,
  align = 'left',
  inverted = false,
}) => {
  const centered = align === 'center';
  const muted = inverted ? 'text-chalk/45' : 'text-gray1';

  return (
    <div className={`mb-12 sm:mb-16 ${centered ? 'text-center' : ''}`}>
      <div
        className={`label-mono ${muted} mb-5 flex items-center gap-2 ${centered ? 'justify-center' : ''}`}
      >
        <span className='text-accent'>[</span>
        {index} / {kicker}
        <span className='text-accent'>]</span>
      </div>

      <h2
        className={`font-display leading-[1.04] text-[clamp(2.2rem,5.5vw,4.25rem)] ${
          inverted ? 'text-chalk' : 'text-ink'
        }`}
      >
        <WordReveal text={title} mode='mask' stagger={0.05} />
      </h2>

      {description && (
        <p
          className={`mt-5 max-w-md text-sm sm:text-base leading-relaxed ${muted} ${centered ? 'mx-auto' : ''}`}
        >
          {description}
        </p>
      )}
    </div>
  );
};

export default SectionHeading;
